<footer
  class="flex flex-wrap align-center justify-center gap-5 px-5 pt-28 pb-5"
>
  <a
    href="https://danzai.es/aviso-legal"
    title="Aviso legal"
    target="_blank"
    class="text-[#005cbb] font-medium text-sm text-center"
    >Aviso legal</a
  >
  <a
    href="https://danzai.es/politica-privacidad"
    title="Política de privacidad"
    target="_blank"
    class="text-[#005cbb] font-medium text-sm text-center"
    >Política de privacidad</a
  >
  <a
    href="https://danzai.es/politica-de-cookies"
    title="Política de cookies"
    target="_blank"
    class="text-[#005cbb] font-medium text-sm text-center"
    >Política de cookies</a
  >
  <span class="text-sm text-gray-400 text-center">
    © {{ today | date : "yyyy" }} Danzai Software
  </span>
</footer>
